import React from 'react';
import { renderText } from './shared/renderers';

export default function TextBlock({ props = {}, theme }) {
  return renderText(props, theme);
}
